import React from 'react';

// ##### ConfirmModal Component - Centered card confirmation within drawer
const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm action", 
  message = "Are you sure you want to proceed?", 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  confirmButtonClass = "bg-red-600 hover:bg-red-700 text-white shadow",
  cancelButtonClass = "px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100"
}) => {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center z-[70] pointer-events-none">
      {/* Centered card */}
      <div className="bg-white p-6 rounded-2xl shadow-2xl border border-gray-200 w-full max-w-md pointer-events-auto">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">{title}</h3>
        <p className="mb-6 text-sm text-gray-600">
          {message}
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className={cancelButtonClass}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-xl ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
